import styled from 'styled-components';

const ContainerHeight = styled.div`
    display: flex;
    height: 100%;
    transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
    width: 100%;
`;

export default ContainerHeight;
